var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-container" },
    [
      _c("div", { staticClass: "fx_paper" }, [
        _c("div", { staticClass: "fx_wrap" }, [
          _c(
            "h3",
            { staticClass: "fx_h3" },
            [
              _vm.systemName
                ? [
                    _vm.logoTxt
                      ? _c("span", { staticClass: "logo_txt" }, [
                          _vm._v(_vm._s(_vm.logoTxt))
                        ])
                      : _vm.logoImg
                      ? _c("img", {
                          staticClass: "logo_xs",
                          attrs: { src: _vm.logoImg }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.logoImg
                      ? _c("el-divider", { attrs: { direction: "vertical" } })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.systemName))
                    ])
                  ]
                : _vm.logoTxt
                ? _c("span", { staticClass: "logo_txt" }, [
                    _vm._v(_vm._s(_vm.logoTxt))
                  ])
                : _vm.logoImg
                ? _c("img", {
                    staticClass: "logo",
                    attrs: { src: _vm.logoImg }
                  })
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "mid_line" }),
          _vm._v(" "),
          _vm.loginTypeStatus
            ? _c("div", { staticClass: "login_types_wrap" }, [
                _vm.loginTypes.includes("password")
                  ? _c(
                      "div",
                      {
                        staticClass: "type_item",
                        class: {
                          type_item_active: _vm.loginType === "password"
                        },
                        on: {
                          click: function($event) {
                            return _vm.typeChange("password")
                          }
                        }
                      },
                      [_vm._v("密码登录")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.loginTypes.includes("code")
                  ? _c(
                      "div",
                      {
                        staticClass: "type_item",
                        class: { type_item_active: _vm.loginType === "code" },
                        on: {
                          click: function($event) {
                            return _vm.typeChange("code")
                          }
                        }
                      },
                      [_vm._v("验证码登录")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.loginTypes.includes("qrCode")
                  ? _c(
                      "div",
                      {
                        staticClass: "type_item",
                        class: { type_item_active: _vm.loginType === "qrCode" },
                        on: {
                          click: function($event) {
                            return _vm.typeChange("qrCode")
                          }
                        }
                      },
                      [_vm._v("扫码登录")]
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "form_wrap",
              style: { paddingTop: _vm.loginTypeStatus ? "10px" : "40px" }
            },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  attrs: { model: _vm.ruleForm, rules: _vm.rules }
                },
                [
                  _vm.loginType === "password"
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "input-item",
                              attrs: { label: "", prop: "account" }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  id: "form-username",
                                  placeholder: "请输入工号/用户名",
                                  "prefix-icon": "el-icon-user",
                                  clearable: ""
                                },
                                nativeOn: {
                                  keydown: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return _vm.focusPassword($event)
                                  }
                                },
                                model: {
                                  value: _vm.ruleForm.account,
                                  callback: function($$v) {
                                    _vm.$set(_vm.ruleForm, "account", $$v)
                                  },
                                  expression: "ruleForm.account"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "input-item",
                              attrs: { label: "", prop: "password" }
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  ref: "passwordInput",
                                  attrs: {
                                    type: _vm.passwordType,
                                    placeholder: "请输入密码",
                                    "prefix-icon": "el-icon-lock",
                                    clearable: ""
                                  },
                                  model: {
                                    value: _vm.ruleForm.password,
                                    callback: function($$v) {
                                      _vm.$set(_vm.ruleForm, "password", $$v)
                                    },
                                    expression: "ruleForm.password"
                                  }
                                },
                                [
                                  _vm.passwordType == "password"
                                    ? _c("i", {
                                        staticClass:
                                          "el-icon-view el-input__icon",
                                        staticStyle: { cursor: "pointer" },
                                        attrs: {
                                          slot: "suffix",
                                          title: "显示密码"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.passwordType = "text"
                                          }
                                        },
                                        slot: "suffix"
                                      })
                                    : _c("i", {
                                        staticClass:
                                          "el-icon-more el-input__icon",
                                        staticStyle: { cursor: "pointer" },
                                        attrs: {
                                          slot: "suffix",
                                          title: "隐藏密码"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.passwordType = "password"
                                          }
                                        },
                                        slot: "suffix"
                                      })
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.needValidate
                            ? _c(
                                "el-form-item",
                                {
                                  staticClass: "wordCode-item",
                                  attrs: { label: "", prop: "validateCode" }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "填写验证码",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.ruleForm.validateCode,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.ruleForm,
                                          "validateCode",
                                          $$v
                                        )
                                      },
                                      expression: "ruleForm.validateCode"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    attrs: { src: _vm.validateUrl },
                                    on: { click: _vm.validateChange }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loginType === "code"
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "input-item",
                              attrs: { prop: "mobile" }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  id: "form-username",
                                  placeholder: "请输入手机号码",
                                  "prefix-icon": "el-icon-mobile-phone",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.ruleForm.mobile,
                                  callback: function($$v) {
                                    _vm.$set(_vm.ruleForm, "mobile", $$v)
                                  },
                                  expression: "ruleForm.mobile"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "fx_verification",
                              attrs: { prop: "code" }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请填写验证码",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.ruleForm.code,
                                  callback: function($$v) {
                                    _vm.$set(_vm.ruleForm, "code", $$v)
                                  },
                                  expression: "ruleForm.code"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "default", size: "mini" },
                                  on: { click: _vm.getVerificationCode }
                                },
                                [_vm._v(_vm._s(_vm.timeText))]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loginType === "qrCode"
                    ? _c("div", { staticClass: "qr-box" }, [
                        _c("img", { attrs: { src: _vm.qrCodeUrl } }),
                        _vm._v(" "),
                        _vm.overTimeShow
                          ? _c("div", { staticClass: "tip-box" }, [
                              _c("div", [_vm._v("二维码已过期")]),
                              _vm._v(" "),
                              _c("div", [_vm._v("请重新获取")]),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "refresh-button",
                                  on: { click: _vm.changeQrCode }
                                },
                                [_vm._v("刷新")]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "bottom-tip" }, [
                          _c("span", { staticStyle: { color: "#fff" } }, [
                            _vm._v("请使用手机扫码登录")
                          ]),
                          _vm.isShowQrOverTime
                            ? _c("span", { staticStyle: { color: "#fff" } }, [
                                _vm._v("(" + _vm._s(_vm.qrNowTime) + "s)")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "i",
                            {
                              staticClass: "el-icon-refresh-right",
                              staticStyle: {
                                color: "#00C0EF",
                                cursor: "pointer"
                              },
                              on: { click: _vm.changeQrCode }
                            },
                            [_vm._v("刷新二维码")]
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loginType !== "qrCode"
                    ? _c(
                        "el-form-item",
                        { staticClass: "btn", attrs: { "label-width": "0px" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { loading: _vm.logining, type: "primary" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.handleSubmit($event)
                                }
                              }
                            },
                            [_vm._v("\n                登录\n              ")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "bottom-box" },
                [
                  _vm.needKeepLogin
                    ? _c("el-checkbox", {
                        attrs: { label: "保持登录状态" },
                        on: { change: _vm.keepLoginChange },
                        model: {
                          value: _vm.keepLoginValue,
                          callback: function($$v) {
                            _vm.keepLoginValue = $$v
                          },
                          expression: "keepLoginValue"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loginTypes.includes("otherLogin")
                    ? _c("div", { staticClass: "other-login" }, [
                        _c(
                          "span",
                          {
                            staticClass: "mr-10",
                            staticStyle: { "line-height": "19px" }
                          },
                          [_vm._v("其他登录方式")]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "circle-button",
                            on: {
                              click: function($event) {
                                return _vm.otherLogin("kayi")
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.otherLoginLabel))]
                        )
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _vm._t("footer")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cae59cf4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cae59cf4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/vlogin/src/VLogin.vue
// module id = null
// module chunks = 